import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 14 minutes 39 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="bg-green-600 text-white py-2 px-4 text-center font-bold sticky top-0 z-50 shadow-lg border-b-4 border-green-800" data-id="element-1">
      <div className="flex items-center justify-center gap-2" data-id="element-2">
        <Clock className="w-4 h-4 text-white animate-pulse" data-id="element-3" />
        <span className="text-sm md:text-base" data-id="element-4">
          OFERTA TERMINA EN:{' '}
          <span className="font-mono font-black text-lg md:text-xl" data-id="element-5">
            {formatTime(timeLeft)}
          </span>
        </span>
      </div>
    </div>;
}